module.exports = __webpack_public_path__ + "static/media/pbm-protocols-ad.8684efb9.png";